export const rewardSite = "https://rewards.pcdealsindia.com/user-dashboard";
export const rewardSiteBaseUrl = "https://rewards.pcdealsindia.com";
export const home = "/";
export const users = "/users";
export const settings = "/settings";
export const currentUrl = window.location.href;


//base url
export let baseUrl = "http://localhost:3000";
if (typeof window !== "undefined" && window.location.host) {
  baseUrl = window.location.protocol + "//" + window.location.host;
}

// string to html
export function shortTextMsg(htmlString, limit) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  const textContent = tempDiv.textContent || tempDiv.innerText || "";
  const words = textContent.trim().split(/\s+/);
  return words.slice(0, limit).join(" ") + (words.length > limit ? "..." : "");
}
